module.exports = __webpack_public_path__ + "static/uber.3adef4ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/uber.png
// module id = 863
// module chunks = 73261030922168